import { render, staticRenderFns } from "./LiveSocialCard.vue?vue&type=template&id=f89721e6&scoped=true&"
import script from "./LiveSocialCard.vue?vue&type=script&lang=ts&"
export * from "./LiveSocialCard.vue?vue&type=script&lang=ts&"
import style0 from "./LiveSocialCard.vue?vue&type=style&index=0&id=f89721e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89721e6",
  null
  
)

export default component.exports